import { connect } from 'react-redux'

import { setSlug } from 'components/Modal/DocumentPopupWindow/reducer'

const mapStateToProps = (state) => {
    return {
        slug: state?.components?.document?.slug,
    }
}

const mapDispatchToProps = { setSlug }

const hocFormRegister = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocFormRegister
